import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { connectStateResults } from 'react-instantsearch-dom';
import { trackProductClick } from '../../utils/tracking';
import { getProductSlug } from '../../organisms/algolia-cms/utils/moduleProducts';

import ProductCard from '../product-card';
import QuickShop from '../product-quick-shop';
import Ruler from '../../atoms/ruler';
import CMSModuleProducts from '../../organisms/algolia-cms/cms-module-products';

const Grid = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: ${(props) => props.theme.width.small};
  margin: 0 auto;
  position: relative;

  > article {
    flex-basis: 50%;
    padding: 0 .7rem;
  }

  img {
    display: block;
    max-width: 100%;
  }

  & ~ & {
    margin-top: 5rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    max-width: ${(props) => props.theme.width.large};

    > article {
      flex-basis: 25%;
    }
  }
`;

const ModuleProducts = connectStateResults((props) => {
  const [quickshop, setQuickshop] = useState(null);
  const products = props.searchResults?.hits;

  return (
    <Grid>
      {
         products?.length > 0 ? products.map((productData, i) => {
           const productSlug = getProductSlug(productData);
           return (
             <Fragment key={productData}>
               <ProductCard
                 product={productData}
                 index={i + 1}
                 module="product"
                 onClick={(e) => {
                   trackProductClick({ productData });
                   const isQuickShop = e.target.dataset.id === 'quickshop';
                   const isWishlist = e.target.dataset.id === 'wishlist';

                   if (isQuickShop || isWishlist) {
                     e.preventDefault();
                   }
                 }}
                 onQuickshopClick={() => setQuickshop(productSlug)}
               />

               {
                  quickshop === productSlug && (
                    <QuickShop
                      inProductModule
                      slug={productSlug}
                      quickShopIndex={i + 1}
                      onQuickshopClose={() => setQuickshop(null)}
                      meta={props.meta}
                    />
                  )
                }
             </Fragment>
           );
         }) : null
        }
    </Grid>
  );
});

const Product = (props) => {
  if (!props.data?.products) {
    return null;
  }

  return props.data?.products.length > 0 && (
    <CMSModuleProducts products={props.data.products}>
      <ModuleProducts meta={props.meta}/>
      {props.data.hr && <Ruler />}
    </CMSModuleProducts>
  );
};

Product.whyDidYouRender = true;

Product.defaultProps = {
  meta: {}
};

Product.propTypes = {
  data: PropTypes.object.isRequired,
  meta: PropTypes.object
};

export default Product;
